<template>
  <div class="auth-card">
    <h2 class="k6-green-text text-center" style="font-weight: 700;">{{ $t("pages.register.register") }}</h2>
    <div style="display: flex; justify-content: center;">
      <button 
        name="GoogleSigninButton"
        @click="loginSsoGoogle"
        class="google-login-btn"
      >
        <img 
          src="../../assets/google.png" 
          class="google-icon"
        />
        {{ $t("pages.login.google") }}
      </button>
    </div>
    
    <form role="form" class="form-horizontal" style="padding: 10px;" @submit.prevent="registerUser">
      <div class="form-group">
        <label for="email" class="col-sm-12">{{$t('pages.register.email')}}</label>
        <div class="col-sm-12">
          <input :value="email" @input="updateRegisterEmail" type="email" 
            class="form-control" id="email" name="email" placeholder="" autofocus required>
        </div>
      </div>
      <div class="form-group">
        <label for="username" class="col-sm-12">{{$t('pages.register.username')}}</label>
        <div class="col-sm-12">
          <input :value="username" @input="updateRegisterUsername" 
            type="text" id="username" name="username" class="form-control" placeholder="" required>
        </div>
      </div>
      <div class="form-group">
        <label for="name" class="col-sm-12">{{$t('pages.register.name')}}</label>
        <div class="col-sm-12">
          <input :value="name" @input="updateRegisterName" 
            id="name" name="name" type="text" class="form-control" placeholder="" required>
        </div>
      </div>
      <div class="form-group">
        <label for="surname" class="col-sm-12">{{$t('pages.register.surname')}}</label>
        <div class="col-sm-12">
          <input :value="surname" @input="updateRegisterSurname" 
            type="text" id="surname" name="surname" class="form-control" placeholder="" required>
        </div>
      </div>
      <div class="form-group">
        <label for="studentId" class="col-sm-12">{{$t('pages.register.studentId')}}</label>
        <div class="col-sm-12">
          <input :value="studentId" @input="updateRegisterStudentId" 
            type="text" id="studentId" name="studentId" class="form-control" placeholder="" pattern="\d{8}">
        </div>
      </div>
      <div class="form-group">
        <label for="password" class="col-sm-12">{{$t('pages.register.password')}}</label>
        <div class="col-sm-12">
          <input :value="password" @input="updateRegisterPassword" type="password" 
            class="form-control" name="password" id="password" placeholder="" required>
        </div>
      </div>
      <div class="form-group">
        <label for="password2" class="col-sm-12">{{$t('pages.register.passwordRetype')}}</label>
        <div class="col-sm-12">
          <input :value="password2" @input="updateRegisterPassword2" type="password" 
            class="form-control" name="password2" id="password2" placeholder="" required>
        </div>
      </div>
      <div class="form-group">
        <vue-recaptcha class="btn" @verify="onVerify" @expired="onExpired" sitekey="6LeIxqYkAAAAAE3nZlQrt-ocv_GZ1YU-XffmNiXq" />
      </div>
      
      <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; gap: 20px">
        <button type="submit" class="k6-primary-btn">{{ $t('pages.register.register') }}</button>
        <div>
          <span>
            {{ $t("pages.register.alreadyHaveAnAccount") }}
            <a class="k6-green-text" @click.prevent="toLogin">{{ $t("pages.login.login") }}</a>
          </span>
        </div>
      </div>
      
    </form>
  </div>

</template>

<script>
  import VueRecaptcha from 'vue-recaptcha'
  import { mapState } from 'vuex'
  import _ from 'lodash'
  export default {
    props: ['loginSsoGoogle', 'switchAuthView'],
    data () {
      return {
        recaptchaSuccess: false
      }
    },
    computed: {
      ...mapState({
        username: state => state.register.username,
        email: state => state.register.email,
        name: state => state.register.name,
        surname: state => state.register.surname,
        password: state => state.register.password,
        password2: state => state.register.password2,
        studentId: state => state.register.studentId,
        status: state => state.register.status
      })
    },
    components: {
      VueRecaptcha
    },
    methods: {
      onSubmit () {
        this.$refs.invisibleRecaptcha.execute()
      },
      onVerify (response) {
        this.recaptchaSuccess = true
        console.log('Verify: ' + response)
      },
      onExpired () {
        console.log('Expired')
      },
      resetRecaptcha () {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      updateRegisterUsername (e) {
        this.$store.commit('updateRegisterUsername', e.target.value)
      },
      updateRegisterEmail (e) {
        this.$store.commit('updateRegisterEmail', e.target.value)
      },
      updateRegisterName (e) {
        this.$store.commit('updateRegisterName', e.target.value)
      },
      updateRegisterSurname (e) {
        this.$store.commit('updateRegisterSurname', e.target.value)
      },
      updateRegisterPassword (e) {
        this.$store.commit('updateRegisterPassword', e.target.value)
      },
      updateRegisterPassword2 (e) {
        this.$store.commit('updateRegisterPassword2', e.target.value)
      },
      updateRegisterStudentId (e) {
        this.$store.commit('updateRegisterStudentId', e.target.value)
      },
      registerUser: _.throttle(function (event) {
        if (!this.recaptchaSuccess) {
          alert(this.$t('pages.register.recap'))
          return
        }
        if (this.password !== this.password2) {
          this.password = ''
          this.password2 = ''
          this.$store.commit('updateRegisterStatus', this.$t('pages.register.mismatch'))
          return
        }
        let dataForRegistration = {
          email: this.email,
          username: this.username,
          firstName: this.name,
          lastName: this.surname,
          studentId: this.studentId,
          password: this.password,
          password2: this.password2
        }
        this.$store.dispatch('register', {
          dataForRegistration,
          callback: () => {
            window.jQuery('#registerSuccessModal').modal('toggle')
            this.switchAuthView('login')
          }
        })
      }, 3000),
      toLogin () {
        this.switchAuthView('login')
      }
    }
  }
</script>

<style>
.form-group.required .control-label:after {
  content:"*";
  color:red;
}
</style>



// WEBPACK FOOTER //
// Register.vue?07f590cb